import { getPriceSettingsExternalPaymentData } from '~/entities/price-settings'
import type { TvChannelPayment } from '../interfaces'
import { getPaymentTvChannelMediaType } from './media-type'

interface FormatChannelExternalPaymentParams {
  channel: TvChannelPayment
  shouldRefresh?: boolean
}
export const formatChannelExternalPayment = ({
  channel,
  shouldRefresh = false,
}: FormatChannelExternalPaymentParams) => {
  const { id, priceSettings, externalId } = channel
  return {
    id,
    mediaType: priceSettings
      ? getPaymentTvChannelMediaType(priceSettings)
      : null,
    shouldRefresh,
    ...getPriceSettingsExternalPaymentData(priceSettings, externalId),
  }
}
